import { Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import AsteriskIcon from 'components/CopilotControl/icons/AsteriskIcon'
import { ConditionTypes } from 'consts/autochartConsts'
import React from 'react'
import { useTranslation } from 'react-i18next'
import LegendImages from 'resources/autochart/Legend'

const useStyles = makeStyles(theme => ({
  img: {
    objectFit: 'contain',
    height: '100%',
    width: '100%'
  },
  label: {
    marginLeft: 12
  }
}))

const AutochartLegendItem = ({ condition, height = '100%' }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const imgHeight = React.useMemo(() => {
    if (typeof height === 'number') {
      return `calc(${height}px - 8px)`
    }
    if (typeof height === 'string' && height.includes('%')) {
      return `calc(${height} - 8px)`
    }
    return 'calc(100% - 8px)'
  }, [height])

  return (
    <Grid container alignItems="center" style={{ height }}>
      {condition === ConditionTypes.Indecisive ? (
        <Grid item>
          <AsteriskIcon />
        </Grid>
      ) : (
        <Grid item style={{ height: imgHeight }}>
          <img alt="" src={LegendImages[condition]} className={classes.img} />
        </Grid>
      )}
      <Grid item className={classes.label}>
        <DazzedParagraph12>{t(`dialogs.autochart.conditions.${condition}`)}</DazzedParagraph12>
      </Grid>
    </Grid>
  )
}

export default AutochartLegendItem
